export default ({ menuId, matchSelector = 'a.highlight-word', offset = 24 }) => {
  const $matches = global.$(`#${menuId}`).find(matchSelector);

  if (!$matches.length) {
    return false;
  }

  let topmost = $matches.get(0);
  let topY = topmost.getBoundingClientRect().top;

  for (let i = 1; i < $matches.length; i++) {
    const el = $matches.get(i);
    const y = el.getBoundingClientRect().top;
    if (y < topY) {
      topmost = el;
      topY = y;
    }
  }

  const scrollTop = Math.max(global.window.pageYOffset + topY - offset, 0);

  global.window.scrollTo({
    top: scrollTop,
    behavior: 'auto',
  });

  return true;
};
